import { useDatabase } from "@nozbe/watermelondb/hooks";
import { Page, useTheme } from "@towersystems/roam-common-native";
import { useEffect, useState } from "react";
import { View } from "react-native-ui-lib";
import PayType from "../../../../utilities/data/model/PayType";

const TYRO_DEV_ID = "15";
const TYRO_PROD_ID = "10";

export const SetupTyroSettingScreen = ({ route }: any) => {
  const [payType, setPayType] = useState<PayType | undefined>(undefined);
  const database = useDatabase();
  const { colors } = useTheme();
  const isDev = route.params.isDev ?? false;

  useEffect(() => {
    database
      .get<PayType>("pay_types")
      .find(isDev ? TYRO_DEV_ID : TYRO_PROD_ID)
      .then((i) => setPayType(i))
      .catch((err) => console.log(err));
  }, []);

  if (!payType) {
    return <View />;
  }

  if (!payType.configurationUrl) {
    return <View />;
  }

  return (
    <Page scrollable={false}>
      <iframe
        style={{
          height: "100%",
          outline: 0,
          borderWidth: 1,
          borderColor: colors.borderColor,
        }}
        src={payType.configurationUrl}
      />
    </Page>
  );
};
